import { Record, Set } from 'immutable';

import { convertActionToPreviousStructure } from 'app/api';
import { ContextNamespace } from 'app/constants/Context';
import {
  CLEANUP_PREMATCH_CONTENT,
  fetchPrematchCategories,
  getPrematchContent,
  SET_MATCHES_CONTAINER_HEIGHT,
} from 'app/modules/Prematch/actions';
import { INIT_ACTION } from 'app/redux/actions/init';
import {
  getFullMatchContent,
  SET_PREMATCH_GRID_ORDER_KEY,
  SET_PREMATCH_GRID_STAKE_TYPES,
} from 'app/redux/betting-presentation/grid/actions';
import { TRANSFORM_SSR_STATE } from 'app/redux/ssrState';

import { reduceGridEntities, reduceMenuEntities } from './entities';
import reducePresentationGrid from './presentation';

// ---


const entitiesState = Record({
  menu: reduceMenuEntities(undefined, INIT_ACTION),
  grid: reduceGridEntities(undefined, INIT_ACTION),
});

const presentationState = Record({
  grid: reducePresentationGrid(
    undefined, ContextNamespace.PREMATCH, INIT_ACTION, undefined,
  ),
});

const initialState = Record({
  fullyLoadedMatches: Set(),
  matchesContainerHeight: null,
  entities: entitiesState(),
  presentation: presentationState(),
});

export const getPrematchReducer = () => (state = initialState(), action) => {
  if (action.type === TRANSFORM_SSR_STATE) {
    if (Record.isRecord(state)) {
      return state; // already transformed (initial state case)
    }

    const gridEntities = reduceGridEntities(state.entities.grid, action);

    return initialState({
      fullyLoadedMatches: Set(state.fullyLoadedMatches),
      matchesContainerHeight: null,
      entities: entitiesState({
        menu: reduceMenuEntities(state.entities.menu, action),
        grid: gridEntities,
      }),
      presentation: presentationState({
        grid: reducePresentationGrid(
          state.presentation.grid, ContextNamespace.PREMATCH, action, gridEntities,
        ),
      }),
    });
  }

  if (action.type === getPrematchContent.fulfilled.toString()) {
    state = state.set('fullyLoadedMatches', Set());
  }

  if (action.type === getFullMatchContent.fulfilled.toString()) {
    state = state.update('fullyLoadedMatches', (state) => {
      return state.add(action.meta.arg.query.id);
    });

    const removeAction = {
      type: getPrematchContent.fulfilled.toString(),
      payload: {
        diff: {
          reset: false,
          removedMatches: [action.meta.arg.query.id],
        },
      },
    };

    state = state.updateIn(['entities', 'menu'], (state) => reduceMenuEntities(state, removeAction));
    state = state.updateIn(['entities', 'grid'], (state) => reduceGridEntities(state, removeAction));
    state = state.updateIn(['presentation', 'grid'], (currentPresentation) => (
      reducePresentationGrid(
        currentPresentation,
        ContextNamespace.PREMATCH,
        removeAction,
        state.get('entities').get('grid'),
      )
    ));

    action = {
      type: getPrematchContent.fulfilled.toString(),
      payload: {
        ...action.payload.data,
        diff: {
          ...action.payload.data.diff,
          reset: false,
        },
      },
    };
  }

  switch (action.type) {
    case SET_MATCHES_CONTAINER_HEIGHT:
      return state.update('matchesContainerHeight', () => action.payload.height);

    case fetchPrematchCategories.pending.toString():
    case fetchPrematchCategories.fulfilled.toString():
    case fetchPrematchCategories.rejected.toString():
      return state.updateIn(['entities', 'menu'], (state) => (
        reduceMenuEntities(state, convertActionToPreviousStructure(action))
      ));

    case getPrematchContent.pending.toString():
    case getPrematchContent.fulfilled.toString():
    case getPrematchContent.rejected.toString():
    case SET_PREMATCH_GRID_ORDER_KEY:
    case SET_PREMATCH_GRID_STAKE_TYPES:
    case CLEANUP_PREMATCH_CONTENT: {
      const convertedAction = convertActionToPreviousStructure(action);

      state = state.updateIn(['entities', 'grid'], (state) => reduceGridEntities(state, convertedAction));
      state = state.updateIn(['presentation', 'grid'], (currentPresentation) => (
        reducePresentationGrid(
          currentPresentation,
          ContextNamespace.PREMATCH,
          convertedAction,
          state.get('entities').get('grid'),
        )
      ));

      return state;
    }
  }

  return state;
};
